import { createContext, useContext } from 'react'

const LanguageContext = createContext()
const LanguageConsumer = LanguageContext.Consumer

function LanguageProvider(props) {
  return <LanguageContext.Provider value={props.value}>{props.children}</LanguageContext.Provider>
}

const useLanguage = () => {
  return useContext(LanguageContext)
}

export default LanguageContext
export { LanguageProvider, LanguageConsumer, useLanguage }
